import { type DragEvent } from "react";

import { SavedUrl } from "./SaveUrls.d";

const SAVED_URLS_KEY = "nexus-saved-urls";

export const loadSavedUrls = (): SavedUrl[] => {
  try {
    const parsed = JSON.parse(localStorage.getItem(SAVED_URLS_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const persistSavedUrls = (data: SavedUrl[]): void => {
  localStorage.setItem(SAVED_URLS_KEY, JSON.stringify(data));
};

export const removeByUrl = (list: SavedUrl[], url: string): SavedUrl[] => list.filter((entry) => entry.url !== url);

export const reorderSavedUrls = (list: SavedUrl[], fromIndex: number, toIndex: number): SavedUrl[] => {
  const updated = [...list];
  const [moved] = updated.splice(fromIndex, 1);
  updated.splice(toIndex, 0, moved);
  return updated;
};

export const setDragData = (event: DragEvent<HTMLElement>, index: number): void => {
  event.dataTransfer.setData("text/plain", String(index));
  event.dataTransfer.effectAllowed = "move";
};

export const allowDrop = (event: DragEvent<HTMLElement>): void => {
  event.preventDefault();
  event.dataTransfer.dropEffect = "move";
};

export const getDragIndex = (event: DragEvent<HTMLElement>): number | null => {
  const sourceIndex = Number(event.dataTransfer.getData("text/plain"));
  return Number.isNaN(sourceIndex) ? null : sourceIndex;
};
